import { createFileRoute } from "@tanstack/react-router";

import { VitalDefinitionList } from "../../../features/vital-definitions/components/vital-definition-list";

/**
 * `RPM-092`'s vital-definition list (`J-296`; `RPM-003`'s Operator surface: "column: vital-definition
 * list — `RPM-092`; control: vital-definition detail — `src/dialog.tsx`"). Read-only here: editing is
 * the platform operator's (`J-297`), and the screen says so in words.
 */
function VitalDefinitionsScreen() {
  return (
    <div className="flex flex-col gap-4 pt-4">
      <VitalDefinitionList />
    </div>
  );
}

export const Route = createFileRoute("/_authenticated/admin/vital-definitions")({
  component: VitalDefinitionsScreen,
  staticData: { screenName: "Vital definitions" },
});
